import theme from "theme";

const { default: styled } = require("@emotion/styled");

const CardContainerStyle = styled.div`
  margin: auto;
  border: 1px solid ${theme.colors.bordertask};
  border-radius: 8px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 5px;
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const HeaderStyle = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #333333;
`;

const CountStyle = styled.span`
  font-size: 12px;
  font-weight: bold;
  color: ${theme.colors.themeColor};
  margin-bottom: 10px;
`;

const ParagaphStyle = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  opacity: 0.7;
  margin-block: 0px;
  padding-block: 0px;
  height: 15px;
`;
const Table = styled.table`
  width: 200px;
`;
const Thead = styled.thead``;
const Tbody = styled.tbody``;

const TR = styled.tr``;

const Th = styled.th`
  color: ${theme.colors.themeColor};
  border-bottom: 1px solid ${theme.colors.bordertask};
  text-align: left;
`;
const Tr = styled.tr`
  margin-bottom: 20px;
`;

const Td = styled.td`
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const SC = {
  CardContainerStyle,
  HeaderStyle,
  HeaderContainer,
  CountStyle,
  ParagaphStyle,
  Table,
  Thead,
  Tbody,
  TR,
  Th,
  Tr,
  Td,
};

export default SC;
